// Shared shape + date helpers for TDL Expiry projects, used by both the
// TDL Expiry list and the project detail screen so they format identically.

export type BillingCycle = 'monthly' | 'quarterly' | 'half_yearly' | 'yearly';

export interface ExpiryRow {
  id: number;
  customer_name: string;
  tdl_name: string;
  first_activation_date: string | null;
  total_amount: number;
  amc_amount: number;
  billing_cycle: BillingCycle;
  start_date: string | null;
  remark: string | null;
  expiry_date: string;
  texpiry: string | null;
  release_version: string | null;
  token: string;
  is_active: number;
}

export const CYCLE_MONTHS: Record<BillingCycle, number> = {
  monthly: 1, quarterly: 3, half_yearly: 6, yearly: 12,
};

export const CYCLE_LABELS: Record<BillingCycle, string> = {
  monthly: 'Monthly', quarterly: 'Quarterly', half_yearly: 'Half-Yearly', yearly: 'Yearly',
};

export const toYMD = (d: string | null) => (d ? d.split('T')[0] : '');

export const fmt = (d: string | null) => {
  if (!d) return '—';
  const [y, m, day] = d.split('T')[0].split('-');
  return `${day}/${m}/${y}`;
};

export const daysBetween = (from: string, to: string) => {
  const a = new Date(from);
  const b = new Date(to);
  return Math.round((b.getTime() - a.getTime()) / 86400000);
};

export const isExpiredDate = (ymd: string) => {
  if (!ymd) return false;
  return ymd < new Date().toISOString().split('T')[0];
};

/** A t-expiry only counts while it pushes the licence past the base expiry date. */
export const hasActiveTexpiry = (r: Pick<ExpiryRow, 'texpiry' | 'expiry_date'>) =>
  !!r.texpiry && !!r.expiry_date && toYMD(r.texpiry) > toYMD(r.expiry_date);

/** The date Tally actually honours — t-expiry when set, otherwise expiry_date. */
export const effectiveExpiry = (r: Pick<ExpiryRow, 'texpiry' | 'expiry_date'>) =>
  hasActiveTexpiry(r) ? toYMD(r.texpiry) : toYMD(r.expiry_date);

export const money = (v: number | null | undefined) =>
  v ? `₹${Number(v).toLocaleString('en-IN')}` : '—';
